<script>
import { Line } from "vue-chartjs";

export const CORES_SERIE = {
  cpu: "#2a78d6",
  memory: "#eb6834",
  disk: "#1baf7a",
};

export default {
  extends: Line,
  props: {
    series: { type: Array, required: true },
  },
  watch: {
    series() {
      this.desenhar();
    },
  },
  mounted() {
    this.desenhar();
  },
  methods: {
    mesmoDia() {
      if (this.series.length < 2) {
        return true;
      }

      const primeiro = String(this.series[0].momento).slice(0, 10);
      const ultimo = String(this.series[this.series.length - 1].momento).slice(0, 10);

      return primeiro === ultimo;
    },

    rotulo(momento) {
      const texto = String(momento);
      const hora = texto.slice(11, 16);

      if (this.mesmoDia()) {
        return hora;
      }

      return texto.slice(8, 10) + "/" + texto.slice(5, 7) + " " + hora;
    },

    linha(rotulo, campo, cor) {
      return {
        label: rotulo,
        data: this.series.map((p) => Number(p[campo])),
        borderColor: cor,
        backgroundColor: cor,
        borderWidth: 2,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBorderWidth: 2,
        pointHoverBorderColor: "#ffffff",
        lineTension: 0.2,
        fill: false,
      };
    },

    desenhar() {
      this.renderChart(
        {
          labels: this.series.map((p) => this.rotulo(p.momento)),
          datasets: [
            this.linha("CPU %", "cpu_percent", CORES_SERIE.cpu),
            this.linha(this.$t("Memory") + " %", "memory_percent", CORES_SERIE.memory),
            this.linha(this.$t("Disk") + " %", "disk_percent", CORES_SERIE.disk),
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          layout: { padding: { top: 4, right: 8 } },
          legend: {
            position: "bottom",
            labels: { usePointStyle: true, boxWidth: 8, padding: 16 },
          },
          hover: { mode: "index", intersect: false },
          tooltips: {
            mode: "index",
            intersect: false,
            backgroundColor: "rgba(26, 26, 25, 0.92)",
            titleMarginBottom: 8,
            bodySpacing: 6,
            callbacks: {
              label: (item, dados) =>
                " " + dados.datasets[item.datasetIndex].label + ": " + Number(item.yLabel).toFixed(1) + "%",
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: 100,
                  stepSize: 25,
                  callback: (valor) => valor + "%",
                  fontColor: "#6b6b66",
                },
                gridLines: { color: "rgba(0, 0, 0, 0.06)", drawBorder: false, zeroLineColor: "rgba(0, 0, 0, 0.12)" },
              },
            ],
            xAxes: [
              {
                ticks: { maxTicksLimit: 7, autoSkip: true, maxRotation: 0, fontColor: "#6b6b66" },
                gridLines: { display: false, drawBorder: false },
              },
            ],
          },
        }
      );
    },
  },
};
</script>
